import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-quotation-item-modal-body" }
const _hoisted_2 = { class: "modal-bar" }
const _hoisted_3 = { class: "modal-title" }
const _hoisted_4 = { class: "actions" }

import { computed, ref } from "vue";
import { useModalStore } from "@/shared/stores/modal";
import { useSnackbarStore } from "@/shared/stores/snackbar";
import AppTextField from "@/shared/components/ui/AppTextField.vue";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { saveTemplateSectionItems } from "@/modules/vendor/services/quotation-templates.api";
import { deleteTemplateSectionItem } from "@/modules/vendor/services/quotation-templates.api";

export type QuotationItemInput = {
  title: string;
  qty: string | number | "";
  unit: string;
  rate: string | number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AddQuotationItemModal',
  props: {
    sectionId: {},
    itemId: {},
    mode: {},
    onAdd: { type: Function },
    onSave: { type: Function },
    onDeleted: { type: Function },
    initial: {}
  },
  setup(__props: any) {

const props = __props;

const modal = useModalStore();
const snackbar = useSnackbarStore();
const isSubmitting = ref(false);
const isDeleting = ref(false);

const name = ref(props.initial?.title ?? "");
const qty = ref<string | number | "">(props.initial?.qty ?? "");
const unit = ref(props.initial?.unit ?? "");
const rate = ref<string | number>(props.initial?.rate ?? 0);

const isValid = computed(() => {
  const n = name.value.trim();
  return Boolean(n);
});

function handleSubmit() {
  if (!isValid.value) return;
  if (isSubmitting.value) return;

  isSubmitting.value = true;

  const payload: QuotationItemInput = {
    title: name.value.trim(),
    qty: qty.value === "" ? "" : qty.value,
    unit: unit.value.trim(),
    rate: rate.value,
  };

  saveTemplateSectionItems(props.sectionId, {
    id: props.mode === "edit" ? props.itemId ?? null : null,
    title: payload.title,
    qty: payload.qty === "" ? null : payload.qty,
    description: null,
    unit: payload.unit || null,
    unit_price: payload.rate ?? null,
    seq_no: null,
  })
    .then(async () => {
      if (props.mode === "edit") {
        await Promise.resolve(props.onSave?.(payload));
      } else {
        await Promise.resolve(props.onAdd?.(payload));
      }

      modal.close();
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Unable to save item.";
      snackbar.error(message);
    })
    .finally(() => {
      isSubmitting.value = false;
    });
}

function handleDelete() {
  if (isSubmitting.value || isDeleting.value) return;
  if (!props.itemId) return;

  isDeleting.value = true;

  deleteTemplateSectionItem(props.itemId)
    .then(async () => {
      return Promise.resolve(props.onDeleted?.());
    })
    .then(() => {
      modal.close();
    })
    .catch((error) => {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Unable to delete item.";
      snackbar.error(message);
    })
    .finally(() => {
      isDeleting.value = false;
    });
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_toolbar, {
      class: "modal-toolbar",
      density: "comfortable",
      flat: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_btn, {
            icon: "",
            variant: "text",
            class: "back-btn",
            "aria-label": "Back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modal).close()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("mdi-arrow-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, _toDisplayString(props.mode === "edit" ? "Edit item" : "Add item"), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_card_text, { class: "body py-6" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_form, {
          class: "form",
          onSubmit: _withModifiers(handleSubmit, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(AppTextField, {
              modelValue: name.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
              label: "Item name",
              placeholder: "e.g. Termite treatment"
            }, null, 8, ["modelValue"]),
            _createVNode(AppTextField, {
              modelValue: qty.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((qty).value = $event)),
              type: "number",
              label: "Qty",
              placeholder: "1"
            }, null, 8, ["modelValue"]),
            _createVNode(AppTextField, {
              modelValue: unit.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((unit).value = $event)),
              label: "Unit",
              placeholder: "e.g. pcs, sqm"
            }, null, 8, ["modelValue"]),
            _createVNode(AppTextField, {
              modelValue: rate.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rate).value = $event)),
              type: "number",
              label: "Rate",
              placeholder: "0.00"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(AppButtonFlat, {
                block: "",
                class: "mb-4",
                type: "submit",
                "prepend-icon": "mdi-check",
                color: "primary",
                loading: isSubmitting.value,
                disabled: isSubmitting.value || !isValid.value || isDeleting.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.mode === "edit" ? "Save" : "Add"), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"]),
              (props.mode === 'edit')
                ? (_openBlock(), _createBlock(AppButtonFlat, {
                    key: 0,
                    block: "",
                    type: "button",
                    "prepend-icon": "mdi-delete-outline",
                    color: "error",
                    variant: "outlined",
                    loading: isDeleting.value,
                    disabled: isDeleting.value || isSubmitting.value,
                    onClick: handleDelete
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" Delete ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading", "disabled"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})